module.exports = __webpack_public_path__ + "static/media/logo-ecityclic.1e737b7c.svg";